import BankTransferIcon from "assets/Desktop/icons/deposit/bank-transfer.svg";
import CryptoIcon from "assets/Desktop/icons/deposit/crypto.svg";
import QRCodeIcon from "assets/Desktop/icons/deposit/qr-code.svg";
import QuickPayIcon from "assets/Desktop/icons/deposit/quick-pay.svg";
import {
  DepositFormSettingType,
  DepositOfflineSubmissionFormNews,
  DepositOnlineSubmission,
} from "types/deposit";

import {
  DepositFormSettingResponse,
  DepositOfflineSubmissionForm,
  DepositOnlineSubmissionForm,
  DepositResponse,
  DepositSubmissionFormType,
} from "./type";

const mockDepositData: DepositFormSettingType = {
  bank: [
    {
      bank_id: "1",
      bank_name: "Ziraat Bankası",
      mobile_image_on: BankTransferIcon,
      web_image_on: BankTransferIcon,
    },
    {
      bank_id: "2",
      bank_name: "Garanti BBVA",
      mobile_image_on: BankTransferIcon,
      web_image_on: BankTransferIcon,
    },
    {
      bank_id: "3",
      bank_name: "İş Bankası",
      mobile_image_on: BankTransferIcon,
      web_image_on: BankTransferIcon,
    },
    {
      bank_id: "4",
      bank_name: "Yapı Kredi",
      mobile_image_on: BankTransferIcon,
      web_image_on: BankTransferIcon,
    },
    {
      bank_id: "5",
      bank_name: "Akbank",
      mobile_image_on: BankTransferIcon,
      web_image_on: BankTransferIcon,
    },
  ],
  player_bank: [
    {
      player_bank_id: "1",
      bank_id: "1",
      bank_name: "Ziraat Bankası",
      bank_account_name: "TK88 MEMBER",
      bank_account_no: "998877665544",
      bank_account_address: "Istanbul",
      web_image_on: BankTransferIcon,
      mobile_image_on: BankTransferIcon,
    },
  ],
  currencies: [
    {
      currency_id: "1",
      currency_name: "TRY",
      currency_code: "TRY",
      currency_symbol: "₺",
      t_currency_rate: 1,
      d_currency_rate: 1,
      w_currency_rate: 1,
      t_free: "0",
      d_fee: "0",
      w_fee: "0",
      is_default: "1",
      active: "1",
    },
    {
      currency_id: "2",
      currency_name: "USD",
      currency_code: "USD",
      currency_symbol: "$",
      t_currency_rate: 1,
      d_currency_rate: 1,
      w_currency_rate: 1,
      t_free: "0",
      d_fee: "0",
      w_fee: "0",
      is_default: "0",
      active: "1",
    },
  ],
  offline_banking_channel: [
    {
      bank_account_id: "1",
      bank_account_name: "TK88 OFFICIAL VIP",
      bank_account_no: "998811223344",
      bank_name: "Ziraat Bankası / Bank Transfer",
      bank_id: "1",
      picture: BankTransferIcon,
      min_deposit: "50",
      max_deposit: "500000",
    },
  ],
  online_banking_channel: [
    {
      id: "1",
      gateway: "Bank QR / Instant Pay",
      picture: QRCodeIcon,
      min_deposit: "50",
      max_deposit: "300000",
      bank: [],
    },
    {
      id: "2",
      gateway: "Crypto USDT (TRC20)",
      picture: CryptoIcon,
      min_deposit: "100",
      max_deposit: "1000000",
      bank: [],
    },
  ],
  hypermart_channel: [],
  promotion: [
    { id: "1", title: "100% First Deposit Bonus up to 10,000 TRY / USD" },
    { id: "2", title: "Daily 5% Unlimited Reload Bonus" },
  ],
  setting: {
    min_deposit: "50",
    max_deposit: "1000000",
  },
  player_fullname: "TK88 Member",
};

export const DepositApi = {
  getDepositForm: async (_username: string) => {
    return {
      data: {
        status: 0,
        msg: "Success",
        data: mockDepositData,
      } as DepositFormSettingResponse,
    };
  },
  OnlineDepositSubmission: async (
    _typename: string,
    _payload: DepositOnlineSubmissionForm
  ) => {
    return {
      data: {
        status: 0,
        msg: "Success",
        data: "https://tk88.com/payment-gateway-demo",
      } as DepositResponse,
    };
  },
  depositSubmission: async (
    _typename: string,
    _payload:
      | DepositOnlineSubmissionForm
      | DepositOfflineSubmissionForm
      | DepositSubmissionFormType
  ) => {
    return {
      data: {
        status: 0,
        msg: "Deposit request submitted successfully",
        data: "https://tk88.com/payment-gateway-demo",
      } as DepositResponse,
    };
  },
  depositSubmissionOffline: async (
    _typename: string,
    _payload: DepositOfflineSubmissionFormNews
  ) => {
    return {
      data: {
        status: 0,
        msg: "Deposit request submitted successfully",
        data: "",
      } as DepositResponse,
    };
  },

  depositSubmissionOnline: async (
    _typename: string,
    _payload: DepositOnlineSubmission
  ) => {
    return {
      data: {
        status: 0,
        msg: "Deposit request submitted successfully",
        data: "https://tk88.com/payment-gateway-demo",
      } as DepositResponse,
    };
  },
};
